import API from '../../utils/Api'
import Router from '@/router'
import i18n from '@/plugins/i18n'

const api = new API('auth')

const state = {
  current: {},
  token: '',
  auth: false,
  loading: false
}

const getters = {
  fullName: state => {
    return state.auth ? state.current.firstname + ' ' + state.current.lastname : ''
  },

  instanceName: state => {
    return state.auth ? state.current.instance.name : ''
  },

  roleLevel: state => state.current.role ? state.current.role : 0,

  current: state => {
    return state.current
  }
}

const actions = {
  async checkIfAlreadyAuth({ commit, state }) {
    try {
      if (state.auth) {
        Router.replace('/')
      }
    } catch (error) {
      commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
    }
  },
  async login({ commit, dispatch, state }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.post(params, '')
      commit('SET_user', res.data)
      commit('interfaceSettings/SET_account', params.account, { root: true })
      await dispatch('interfaceSettings/changeLang', state.current.lang, { root: true })
      commit('interfaceSettings/SET_notification', {success: true, message : i18n.t('notifications.users.welcome') + res.data.user.firstname + " " + res.data.user.lastname}, { root: true })
      commit('SET_loading', false)
      Router.push('/')
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', {success: false, message : error.response.data.message}, { root: true })
    }
  },
  async logout({ commit }) {
    try {
      commit('UNSET_user')
      Router.push('/login')
    } catch (error) {
      commit('interfaceSettings/SET_notification', {success: false, message : error.message}, { root: true })
    }
  },
  async sessionExpired({ commit }) {
    commit('UNSET_user')
    commit('interfaceSettings/SET_notification', {success: false, message : i18n.t('notifications.users.sessionExpired')}, { root: true })
    Router.push('/login')
  }
}

const mutations = {
  UNSET_user(state) {
    state.current = {}
    state.token = null
    state.auth = false
  },
  SET_user(state, params) {
    state.current = params.user
    state.token = params.token
    state.auth = true
  },
  SET_current(state, current) {
    state.current = current
  },
  SET_loading(state, val) {
    state.loading = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}